import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  CircularProgress,
  Divider,
  Button,
} from "@mui/material";
import { useQuotes } from "./hooks/useQuotes";
import { RiveByKey } from "@components/riveAnimation";

export const QuotesSummary = ({ onDataStateChange }) => {
  const { getAllQuotes, quotes, loading } = useQuotes();
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  useEffect(() => {
    const loadQuotes = async () => {
      await getAllQuotes();
      setHasLoadedOnce(true);
    };

    loadQuotes();
  }, []);

  const cellSx = {
    fontWeight: 800,
    color: "var(--fx-surface-texttertiary, #94A3B8)",
    fontSize: "0.625rem",
    textTransform: "uppercase",
    padding: "12px 16px",
    borderBottom: "1px solid var(--fx-surface-border, #E2E8F0)",
  };

  const hasData = quotes?.items?.length > 0;
  //const hasData = false;

  useEffect(() => {
    onDataStateChange?.({ hasData: hasLoadedOnce ? hasData : null, loading: loading || !hasLoadedOnce });
  }, [hasData, hasLoadedOnce, loading, onDataStateChange]);

  if (loading)
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress size={20} />
      </Box>
    );
  if (!hasData) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" sx={{}}>
        {/* <Lottie options={lottieOptions} height={100} width={100} isClickToPauseDisabled /> */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            marginTop: -8,
          }}
        >
          <RiveByKey riveKey="timesheets" boxSize={200} />
        </Box>
        <Typography variant="body2" sx={{ display: "flex", mt: -2, color: "text.secondary", textAlign: "center", fontSize: "0.85rem", opacity: 0.8 }}>
          No quotes registered yet
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Box>
        <Typography variant="subtitle1" sx={{ color: "#f59e0b", fontSize: "16px", fontWeight: 600 }}>
          Active Quotes
        </Typography>
      </Box>

      <TableContainer component={Paper} elevation={0} sx={{ border: "1px solid var(--fx-surface-border, #E2E8F0)", borderRadius: 4 }}>
        <Table size="small" padding="none">
          <TableHead>
            <TableRow sx={{ backgroundColor: "var(--fx-surface-base, #FFFFFF)" }}>
              <TableCell sx={cellSx}>ID</TableCell>
              <TableCell sx={cellSx}>Client</TableCell>
              <TableCell sx={cellSx} align="center">
                Deposit
              </TableCell>
              <TableCell sx={cellSx} align="right">
                Status
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody sx={{ fontSize: "10px" }}>
            {quotes.items.slice(0, 5).map((quote) => (
              <TableRow key={quote.id} sx={{ "&:hover": { bgcolor: "var(--fx-surface-sunken, #F8FAFC)", gap: 10 } }}>
                {/* ID */}
                <TableCell sx={{ px: 2, py: 1, color: "var(--fx-surface-textsecondary, #64748B)", fontSize: "10px", fontWeight: 400 }}>#{quote.id}</TableCell>

                {/* CLIENT */}
                <TableCell sx={{ px: 2, py: 1 }}>
                  <Typography variant="body3" sx={{ fontSize: "12px", fontWeight: 400, color: "var(--fx-surface-text, #0F172A)" }}>
                    {quote.client?.clientCompanyName || `${quote.client?.firstName} ${quote.client?.lastName}`}
                  </Typography>
                </TableCell>

                {/* DEPOSIT */}
                <TableCell align="center" sx={{ px: 2, py: 1 }}>
                  <Typography variant="body3" sx={{ fontSize: "12px", fontWeight: 400 }}>
                    ${(quote.depositAmount || 0).toLocaleString()}
                  </Typography>
                </TableCell>

                {/* STATUS (Pago) */}
                <TableCell align="right" sx={{ px: 2, py: 1 }}>
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: "12px",
                      fontWeight: 400,
                      color: quote.depositInvoice?.paidAt ? "#10b981" : "#f59e0b",
                    }}
                  >
                    {quote.depositInvoice?.paidAt ? "PAID" : "PENDING"}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default QuotesSummary;
